export enum MoveToFolderScenario {
    MoveTo = 1,
    CopyTo,
    RunRuleNow,
    FolderMoveTo,
    SelectSearchFolder,
    GoToFolder,
}
